import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { useWeblab } from '@amzn/sustainability-central-shared-react';

import { ASX_REBRANDING } from 'src/constants';
import { THEME } from 'src/enums/theme';
import amzLogoBlack from 'src/images/Amazon_Logo_Black.png';
import amzLogoWhite from 'src/images/Amazon_Logo_White.png';
import amzLogoWhiteRebranding from 'src/images/Amazon_Logo_White_Rebranding.png';

import styles from './Logo.module.scss';

type StyleVariant = 'primary' | 'secondary';

interface LogoProps {
  altText: string;
  href: string;
  styleVariant?: StyleVariant;
  theme?: THEME;
}

export const Logo: FunctionComponent<LogoProps> = ({
  altText,
  href,
  styleVariant = 'primary',
  theme = THEME.LIGHT,
}) => {
  const asxRebrandingWeblab = useWeblab(ASX_REBRANDING);
  const isRebrandingWeblabEnabled = asxRebrandingWeblab === 'T1';

  let srcImage;

  if ((theme === THEME.DARK || theme === THEME.REBRAND_DARK) && !isRebrandingWeblabEnabled) {
    srcImage = amzLogoWhite;
  } else if ((theme === THEME.DARK || theme === THEME.REBRAND_DARK) && isRebrandingWeblabEnabled) {
    srcImage = amzLogoWhiteRebranding;
  } else if (styleVariant === 'primary' || theme === THEME.REBRAND_LIGHT) {
    srcImage = amzLogoBlack;
  } else {
    srcImage = amzLogoWhite;
  }

  return (
    <a className={classNames(styles.link, isRebrandingWeblabEnabled && styles.rebranding)} href={href}>
      <img
        alt={altText}
        className={classNames(styles.logo, styles.amzLogo, isRebrandingWeblabEnabled && styles.rebranding)}
        src={srcImage}
      />
    </a>
  );
};
